import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import Api from "../Service/Api";
import NavBar from "../Components/NavBar";
import Loaders from "../Components/FullScreenLoader";
import logo from "../../static/Images/logo.png";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [formError, setFormError] = useState("");
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const clearErrors = () => setFormError("");

  const handleSubmit = (event) => {
    event.preventDefault();
    setValidated(true);
    setFormError("");

    const form = event.currentTarget;
    if (!form.checkValidity()) {
      return;
    }

    if (password.length < 8) {
      setFormError("Password must be at least 8 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setFormError("Passwords do not match.");
      return;
    }

    const mobileDigits = String(mobile).replace(/\D/g, "");
    if (mobileDigits.length !== 10) {
      setFormError("Please enter a valid 10-digit mobile number.");
      return;
    }

    setLoading(true);

    Api.post("/auth/signup", {
      name: name.trim(),
      mobile: mobileDigits,
      email: email.trim(),
      password,
    })
      .then((res) => {
        if (res.status === 201) {
          history.replace("/login");
          return;
        }
        setFormError("This email is already registered. Try signing in.");
        setLoading(false);
      })
      .catch((err) => {
        const message =
          err?.response?.data?.message ||
          "Could not create your account. Please try again.";
        setFormError(message);
        setLoading(false);
      });
  };

  return (
    <div className="auth-layout">
      <NavBar />
      {loading && <Loaders />}

      <section className="login-page login-page--signup">
        <div className="login-page__backdrop" aria-hidden="true" />

        <div className="container login-page__container">
          <Row className="justify-content-center">
            <Col xs={12} sm={11} md={10} lg={10} xl={9}>
              <Card className="login-page__card">
                <Row className="g-0">
                  <Col
                    md={5}
                    className="login-page__panel login-page__panel--brand d-none d-md-flex"
                  >
                    <div className="login-page__brand-content">
                       
                      <h2 className="login-page__brand-title">
                        Join the adventure
                      </h2>
                      <p className="login-page__brand-text">
                        Create your account to discover treks, save wishlists,
                        and book unforgettable experiences with trusted
                        operators.
                      </p>
                    </div>
                  </Col>

                  <Col md={7} className="login-page__panel login-page__panel--form">
                    <div className="login-page__form-wrap login-page__form-wrap--signup">
                      <div className="login-page__mobile-brand d-md-none">
                        
                      </div>

                      <h1 className="login-page__title">Create your account</h1>
                    

                      {formError && (
                        <div
                          className="login-page__alert"
                          role="alert"
                          aria-live="polite"
                        >
                          {formError}
                        </div>
                      )}

                      <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                        className="login-page__form login-page__form--signup"
                      >
                        <Form.Group controlId="signupName">
                          <Form.Label>Full name</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Your full name"
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value);
                              clearErrors();
                            }}
                            autoComplete="name"
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter your full name.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="signupEmail">
                          <Form.Label>Email address</Form.Label>
                          <Form.Control
                            required
                            type="email"
                            placeholder="name@example.com"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              clearErrors();
                            }}
                            autoComplete="email"
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid email address.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="signupMobile">
                          <Form.Label>Mobile number</Form.Label>
                          <Form.Control
                            required
                            type="tel"
                            placeholder="10-digit mobile number"
                            value={mobile}
                            onChange={(e) => {
                              setMobile(e.target.value.replace(/\D/g, "").slice(0, 10));
                              clearErrors();
                            }}
                            pattern="[0-9]{10}"
                            maxLength={10}
                            autoComplete="tel"
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter a valid 10-digit mobile number.
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Row>
                          <Col xs={12} md={6}>
                            <Form.Group controlId="signupPassword">
                              <Form.Label>Password</Form.Label>
                              <Form.Control
                                required
                                type="password"
                                placeholder="Min. 8 characters"
                                value={password}
                                minLength={8}
                                isInvalid={
                                  validated && password.length > 0 && password.length < 8
                                }
                                onChange={(e) => {
                                  setPassword(e.target.value);
                                  clearErrors();
                                }}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">
                                Password must be at least 8 characters.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col xs={12} md={6}>
                            <Form.Group controlId="signupConfirmPassword">
                              <Form.Label>Confirm password</Form.Label>
                              <Form.Control
                                required
                                type="password"
                                placeholder="Re-enter password"
                                value={confirmPassword}
                                isInvalid={
                                  validated &&
                                  confirmPassword.length > 0 &&
                                  password !== confirmPassword
                                }
                                onChange={(e) => {
                                  setConfirmPassword(e.target.value);
                                  clearErrors();
                                }}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">
                                Passwords do not match.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>

                        <p className="login-page__note">
                          After signing up, check your email to verify your
                          account before booking.
                        </p>

                        <Button
                          type="submit"
                          className="login-page__submit"
                          disabled={loading}
                        >
                          Create account
                        </Button>
                      </Form>

                      <p className="login-page__signup">
                        Already have an account?{" "}
                        <Link to="/login" className="login-page__link login-page__link--bold">
                          Sign in
                        </Link>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default Register;
